module.exports = __webpack_public_path__ + "static/media/Gallery_Grid_2-min.955dd48f.jpg";